import Styled from 'styled-components';

const CardImageWrap = Styled.div`
  text-align: center;
  img {
    max-width: 100%;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }
`;

const CardActionsWrap = Styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 16px;

  button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
`;

const DigitalCardsWrapper = Styled.div`
  .action-buttons {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }

  .preview-image-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px 0;

    img {
      max-width: 100%;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      margin-bottom: 16px;
    }
  }
`;

export { CardImageWrap, CardActionsWrap, DigitalCardsWrapper };
